import { ImageAnnotations } from 'app/interfaces/Image';
import { CropAnnotation } from 'app/CornerstoneTools/types';

export const convertCropAnnotationToCropRect = (cropAnnotation: CropAnnotation) => {
  if (!cropAnnotation) return undefined;

  const { topLeft, end } = cropAnnotation?.handles ?? {};
  let cropRect;
  if (topLeft && end) {
    const { x, y } = topLeft;
    const { x: xEnd, y: yEnd } = end;
    cropRect = [Math.min(x, xEnd), Math.min(y, yEnd), Math.abs(xEnd - x), Math.abs(yEnd - y)].map(
      Math.round
    );
  }
  return cropRect as [number, number, number, number];
};

export const convertCropAnnotationsToCropRect = (cropAnnotations: ImageAnnotations['Crop']) => {
  if (!cropAnnotations) return undefined;

  const [cropUUID] = Object.keys(cropAnnotations);
  if (!cropUUID) return undefined;
  return convertCropAnnotationToCropRect(cropAnnotations?.[cropUUID]);
};
